import { UploadDocument } from "../models/UploadDocument";
import { ServiceResponse } from "../models/ServiceResponse";
import { UploadDocumentResponse } from "../models/UploadDocumentResponse";
import { DocumentsFiling } from "../models/DocumentsFiling";
import { AuthorizedUser } from "../models/AuthorizedUser";
import { http } from "../http/Http";

export class DocumentService {

    uploadDocument = async (uploadDocument: UploadDocument): Promise<ServiceResponse<UploadDocumentResponse>> => {
        const { data } = await http.put<ServiceResponse<UploadDocumentResponse>>("Document/UploadDocument", uploadDocument);
        return data;
    };

    getShipmentDocumentsByShipmentNumber = async (entityNumber: string,filterCustomreView:boolean = false): Promise<ServiceResponse<DocumentsFiling[]>> => {
        const { data } = await http.get<ServiceResponse<DocumentsFiling[]>>("Document/GetShipmentDocumentsByShipmentNumber/" + entityNumber + "/" + filterCustomreView);
        return data;
    };
    
    getDocumentsFilingExtended = async (documentsFilling : DocumentsFiling ): Promise<ServiceResponse<DocumentsFiling>> => {
        const { data } = await http.post<ServiceResponse<DocumentsFiling>>("Document/DocumentsFilingExtended" , documentsFilling);
        return data;
    };

    updateDocumentsFilings = async (documentsFilling : DocumentsFiling ): Promise<ServiceResponse<DocumentsFiling>> => {
        const { data } = await http.put<ServiceResponse<DocumentsFiling>>("Document/DocumentsFilings" , documentsFilling);
        return data;
    };

    // getLDocumentDownloadToken = async (): Promise<ServiceResponse<string>> => {
    //     const { data } = await http.get<ServiceResponse<string>>("Document/GetDocumentDownloadToken");
    //     return data;
    // };

    // downloadDocument = async (documentSecurityId: string): Promise<string | null> => {
    //     let downloadDocumentUrl = "Download/DownloadDocument?securityId=" + documentSecurityId + "&authorizationToken=" + AuthorizedUser.getToken();
    //     return http.getFullUrl(downloadDocumentUrl);
    // };
}